import React from 'react';

const AdminPage = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Admin Bereich</h1>
    <p>Dieser Bereich ist geschützt.</p>
  </div>
);

export default AdminPage;
